import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import SvgIcon from 'src/components/SvgIcon'
import styles from './LinkButton.module.less'

const LinkButton = ({ children, className, href, iconType, ...rest }) => {

  const classNames = cx({
    'kiosk-color-primary--background': true,
    'kiosk-color-primary-contrast-color': true,
    'kiosk-color-primary-contrast-color-hover': true,
    [styles.linkButton]: true,
    [className]: !!className,
  })

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={classNames} {...rest}>
      {iconType && <SvgIcon type={iconType} className={styles.linkButtonIcon}/>}
      <span>{children}</span>
    </a>
  )
}

LinkButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  iconType: PropTypes.string,
}

export default LinkButton
